import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { MiddlewareService } from './services/middleware/middleware.service';
import { HttpClientModule } from '@angular/common/http';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { AppRoutingModule } from './app-routing.module'

import { AppComponent } from './app.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule
  ],
  providers: [MiddlewareService, GoogleAnalyticsService],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule { }
